/* eslint no-new: "off", class-methods-use-this: "off" */

import $ from "jquery";

class HeidenhainTabMenu {
  /**
   * contains DOM obeject class
   * @type {String}
   */
  tabIdentifier;

  /**
   * contains DOM element
   * @type {*|jQuery|HTMLElement}
   */
  tabHtmlElement;

  /**
   * contains tab headers
   * @type {Array}
   */
  headers = [];

  /**
   * header identifier class
   * @type {string}
   */
  tabNavigationIdentifier = ".js-tab-menu--navigation";

  /**
   * enable heidenhainTabMenu navigation
   * @type {boolean}
   */
  enableNavigation = true;

  constructor(tabIdentifier, enableNavigation) {
    this.tabIdentifier = tabIdentifier;
    this.tabHtmlElement = $(tabIdentifier);

    if (typeof enableNavigation !== "undefined") {
      this.enableNavigation = enableNavigation;
    }

    // generate tab navigation
    if (this.enableNavigation) {
      this.setHeaders();
      this.generateTabNavigation();
      this.setStylingClass();
    }

    this.initOnClickEvent();
    this.openOnError();
  }

  /**
   * Generate a new tab navigation
   */
  generateTabNavigation() {
    $.each(this.headers, (index, header) => {
      // Generate a new list element
      this.tabHtmlElement
        .find(this.tabNavigationIdentifier)
        .append(
          `<li class="js-tab-menu--navigation-element" data-id="${$(
            header
          ).attr("data-id")}"><span>${$(header).text()}</span></li>`
        );

      // Initialize Set visibility class on first tab element
      if (index === 0 && !this.tabHtmlElement.hasClass("js-tab-menu--hidden")) {
        this.setVisibilityClass($(header).attr("data-id"));
      }
    });
  }

  /**
   * remove visibility class on each elements
   */
  removeVisibilityClass(id) {
    if (typeof id === "undefined") {
      this.tabHtmlElement
        .find(
          ".js-tab-element,.js-tab-content,.js-tab-header,.js-tab-menu--navigation-element"
        )
        .removeClass("active");
    } else {
      this.tabHtmlElement
        .find(
          `.js-tab-element[data-id=${id}],.js-tab-content[data-id=${id}],.js-tab-header[data-id=${id}],.js-tab-menu--navigation-element[data-id=${id}]`
        )
        .removeClass("active");
    }
  }

  /**
   * initialize all click events
   */
  initOnClickEvent() {
    // Tab Events
    this.tabHtmlElement
      .find(".js-tab-menu--navigation-element")
      .on("click touchstart", (e) => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        if ($this.hasClass("active")) {
          this.removeVisibilityClass();
        } else {
          this.removeVisibilityClass();
          this.setVisibilityClass($this.attr("data-id"));
        }
      });

    // Accordion Events (e.g. on mobile)
    this.tabHtmlElement.find(".js-tab-header").on("click touchstart", (e) => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      if ($this.hasClass("active")) {
        this.removeVisibilityClass($this.attr("data-id"));
      } else {
        this.setVisibilityClass($this.attr("data-id"));
      }
    });
  }

  /**
   * set all header
   */
  setHeaders() {
    this.headers = $(
      `${this.tabIdentifier} > .js-tab-wrapper .js-tab-element > .js-tab-header`
    );
  }

  /**
   * set visibility class on each element with current ID
   */
  setVisibilityClass(id) {
    $(
      `.js-tab-element[data-id=${id}],.js-tab-content[data-id=${id}],.js-tab-header[data-id=${id}],.js-tab-menu--navigation-element[data-id=${id}]`
    ).addClass("active");
  }

  /**
   * Add dynamic styling class
   */
  setStylingClass() {
    this.tabHtmlElement.addClass(`tab-menu--${this.headers.length}`);
  }

  openOnError() {
    if ($("#error_message").length) {
      $(".js-tab-header, .js-tab-content, .js-tab-element").addClass("active");
    }
  }
}

(() => {
  new HeidenhainTabMenu(".js-tab-menu-form", false);
})();
